import React, { useEffect, useState } from 'react';

import { Transfer } from 'antd';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { COLORS } from '../../utils/theme/colors';

interface IOperationsTransfer {
  targetKeys: any[];
  setTargetKeys: React.Dispatch<any>;
  dataSource: any;
  menuKey: any;
  maxHeight?: number;
}

const OperationsTransfer = ({
  targetKeys,
  setTargetKeys,
  dataSource,
  menuKey,
  maxHeight,
}: IOperationsTransfer): any => {
  const [selectedKeys, setSelectedKeys] = useState();

  const onChange = (nextTargetKeys: any[]) => {
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys: any[], currentKeys) => {
    setSelectedKeys(currentKeys);

    setTargetKeys([...targetKeys, ...sourceSelectedKeys]);
  };

  useEffect(() => {
    setTargetKeys([]);
  }, [menuKey, setTargetKeys]);

  return (
    <OperationsTransferWrapper>
      <Transfer
        dataSource={dataSource?.cpList?.map(
          (chargePoint: { chargeBoxId: any; chargeBoxDescription: any }) => {
            return {
              key: chargePoint.chargeBoxId,
              title: `${
                chargePoint.chargeBoxDescription !== '-'
                  ? chargePoint.chargeBoxDescription
                  : chargePoint.chargeBoxId
              }`,
              description: chargePoint.chargeBoxDescription || '',
            };
          },
        )}
        titles={[T('Available'), T('Selected')]}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onChange={onChange}
        onSelectChange={onSelectChange}
        render={(item) => item?.title || ''}
        showSearch
        filterOption={(inputValue, option) =>
          option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        }
        listStyle={{
          width: 250,
          height: maxHeight || 722,
        }}
      />
    </OperationsTransferWrapper>
  );
};

const OperationsTransferWrapper = styled.div`
  // border: 1px solid ${COLORS.primary};
  margin: 0.5em 1em 0.5em 0;

  .ant-transfer-list-header-selected,
  .ant-transfer-list-header-title {
    color: ${COLORS.primary};
  }

  .ant-transfer-list-body {
    background-color: #fff;
  }
`;

export default OperationsTransfer;
